export default __webpack_public_path__ + "static/media/yucebeybir9.301a008f.jpg";